import React, { useEffect, useState } from 'react';
import notification from 'antd/lib/notification'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { calendar, cancel } from '../../assets/images';
import { PreEmpPackageSelector } from '../common/atoms';
import { dropdownDownArrow } from '../../assets/images'
import { handleAppError } from '../handlers';
import moment from 'moment';
import { employeeDataApi } from '../../services';
import Dropdown from '../common/atoms/Dropdown';
import { ALL_COUNTRIES_ISD_CODES } from '../../constants/overview';
import { dsButtonDisabledPrimary, dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';

const PreEmpBookAppointmentModal = ({ employeeID, appointmentRequestId, employeeName, employeeEmail, employeeMobileNumber, employeeIsdCode, employeeGender, employeeDOB, employeeDOJ, BookAppointmentHandler, benefitType }) => {
  const [state, setState] = useState({
    employees: [], loading: true, employeeID: employeeID, appointmentRequestId: appointmentRequestId, employeeName: employeeName, employeeGender: employeeGender, employeeMobileNumber: employeeMobileNumber, employeeIsdCode: employeeIsdCode,
    employeeEmail: employeeEmail, employeeDOB: employeeDOB, employeeDOJ: employeeDOJ, packageName: null, packageType: null,
    empUpdateError: true, packages: [], packageID: undefined, splitPackageID: undefined, splitPackageName: null, splitPackageType: null,
    benefitType: benefitType, benefitAvailed: false
  })

  const [openDropdown, updateOpenDropdown] = useState(false)
  const [isdCode, setIsdCode] = useState(state.employeeIsdCode|| '+91')
  const allCountryIsdCode = ALL_COUNTRIES_ISD_CODES.map(code => ({...code, disabled: ( code.id !== isdCode ) }))

  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }

  const updateSelectedItem = (item) => {
    setIsdCode(item.id)
    updateOpenDropdown(false)
  }

  const dob = state.employeeDOB ? new Date(moment(state.employeeDOB, 'DD-MM-YYYY')) : null
  const doj = state.employeeDOJ ? new Date(moment(state.employeeDOJ, 'DD-MM-YYYY')) : null

  useEffect(() => {
    fetchPackages()
    setSubState({ loading: false })
  }, [])

  const fetchPackages = () => {
    let that = this
    let url = window.API_URL + "corporate/appointment-requests/" + state.employeeID + "/packages?company_id=" + sessionStorage.getItem('company_id') + `&benefit_type=${state.benefitType}`
    window.axios.get(url)
      .then(function (response) {
        if (response.data.packages) {
          setSubState({ packages: response.data?.packages })
        }
        setSubState({ loading: false })
      })
      .catch(function (error) {
        handleAppError(error)
        setSubState({ loading: false })
      })
  }

  const updateMobileHandler = (name, value) => {
    let validation = true
    if (true) {
      if (value.length === 0) {
        notification['error']({
          message: 'Mobile Number Should not be empty',
          description: "please enter mobile number"
        })
        validation = false
      }
    }
    if (validation && value !== state.employeeMobileNumber) {
      changeHandler(name, value)
    }
  }

  const changeHandler = (name, value) => {
    setSubState({ employeeMobileNumber: value })
  }

  const updatePackageId = (value) => {
    const selectedPackage = state.packages.find(item => item.id === value);
    setSubState({ packageID: value, packageName: selectedPackage?.name, packageType: selectedPackage?.collection_type })
  };

  const updateSplitPackageId = (value) => {
    const selectedPackage = state.packages.find(item => item.id === state.packageID);
    const splitPackage = selectedPackage?.next_packages?.find(item => item.id === value);
    setSubState({ splitPackageID: value, splitPackageName: splitPackage?.name, splitPackageType: splitPackage?.collection_type });
  };

  const isSelectedPackageSplit = () => {
    const selectedPackage = state.packages.find(item => item.id === state.packageID);
    if ((selectedPackage?.next_packages || []).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const splitPackages = () => {
  const splitPackages = [];
  const selectedPackage = state.packages.find(item => item?.id === state.packageID);

  if (!selectedPackage) return splitPackages;

  const formatName = (name, packageName) => `${name ?? ''} ${packageName ?? ''}`.trim();

  splitPackages.push({
    ...selectedPackage,
    name: formatName(selectedPackage.name, selectedPackage.package_name),
  });

  const nextPackages = Array.isArray(selectedPackage.next_packages) ? selectedPackage.next_packages : [];

  for (const pkg of nextPackages) {
    splitPackages.push({
      ...pkg,
      name: formatName(pkg.name, pkg.package_name),
    });
  }

  return splitPackages;
};

  const validate = () => {
    if (state.employeeMobileNumber == null || state.employeeMobileNumber?.length === 0) {
      notification['error']({
        message: 'Mobile Number Should not be empty',
        description: "please enter mobile number"
      })
      return false
    }
    if (state.packageID == null) {
      notification['error']({
        message: 'Package should not be empty',
        description: "Please select package"
      })
      return false
    }
    if (isSelectedPackageSplit() && state.splitPackageID == null) {
      notification['error']({
        message: 'Split Package should not be empty',
        description: "Please select split package"
      })
      return false
    }
    if (state.employeeDOB === null) {
      notification['error']({
        message: 'Date of Birth should not be empty',
        description: "Please enter Date of Birth"
      })
      return false
    }
    return true
  }

  const getInitials = (fullName) => {
    const names = fullName ? fullName.split(" ") : [];
    if (names.length > 2) {
      const firstInitial = names[0].charAt(0).toUpperCase();
      const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
      return firstInitial + lastInitial;
    }
    const initials = names.map(name => name.charAt(0).toUpperCase());
    return initials.join("");
  }

  const buttonHandler = () => {
    if (validate()) {
      let package_id = isSelectedPackageSplit() ? state.splitPackageID : state.packageID;
      let package_name = isSelectedPackageSplit() ? state.splitPackageName : state.packageName;
      let package_type = isSelectedPackageSplit() ? state.splitPackageType : state.packageType
      BookAppointmentHandler(state.employeeMobileNumber, package_id, package_name, package_type, isdCode)
    }
  }

  const formatUserInfo = () => {
    let formattedText = "";
    const email = state.employeeEmail
    const gender = state.employeeGender

    if (gender) {
      formattedText += gender + " · ";
    }
    if (email) {
      formattedText += email;
    }
    if (formattedText.endsWith(" · ")) {
      formattedText = formattedText.slice(0, -3);
    }
    return formattedText;
  }

  const cancelHandler = () => {
    setSubState({ employeeMobileNumber: '' })
  }

  const updateDob = (val) => {
    let url = window.API_URL + "corporate/appointment-requests/customer_update?company_id=" + sessionStorage.getItem('company_id')
    window.axios.post(url, { id: state.appointmentRequestId, date_of_birth: val })
      .then(function () {
        notification['success']({
          message: 'Date of Birth has been updated'
        })
      })
      .catch(function (error) {
        handleAppError(error);
      })
  }

  const updateDoj = (date) => {

    const options = {
      params: {
        id: state.appointmentRequestId,
        date_of_joining: date
      },
    }
    employeeDataApi.pre_emp_update_apptReq(options,
      (resp) => {
        notification['success']({
          message: 'Date of Joining has been updated'
        })
      },
      (err) => {
        handleAppError(err)
      }
    )
  }

  const changeDOB = (value) => {
    let selectedDate = moment(value, 'DD-MM-YYYY').format('DD-MM-YYYY')
    setSubState({ employeeDOB: selectedDate })
    updateDob(selectedDate)
  }

  const changeDOJ = (value) => {
    let selectedDate = moment(value, 'DD-MM-YYYY').format('DD-MM-YYYY')
    setSubState({ employeeDOJ: selectedDate })
    updateDoj(selectedDate)
  }

  const cancelDob = () => {
    setSubState({ employeeDOB: null })
  }

  const cancelDoj = () => {
    setSubState({ employeeDOJ: null })
  }

  return (
    <div className=' pt-6 flex-col flex justify-between h-full' style={{ background: '#F9FAFB' }}>
      {!state.loading && <div className='px-6'>
        <div className='bg-white h-16 flex border rounded-md items-center' >
          <div className='rounded-full border flex justify-center items-center text-center m-2' style={{ background: '#E6F3F0', width: '2.5rem', height: '2.5rem' }}>
            <div className='font-bold text-base'>{getInitials(state.employeeName)}</div>
          </div>
          <div className='m-2 flex-column justify-between justify-items-center items-center'>
            <div className='font-bold text-lg leading-5'>{state.employeeName}</div>
            <div className='text-sm text-gray-500'>{formatUserInfo()}</div>
          </div>
        </div>
        <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3 mb-2'>DOB</div>
        <div className={`flex bg-white items-center border-gray-200 border justify-center mr-2 rounded py-1 w-full rounded-md`}>
          <img src={calendar} style={{ width: 14 }} alt='calender' className=' mx-4' />
          <DatePicker
            onChange={(e) => changeDOB(e)}
            selected={dob}
            placeholderText="DD-MM-YYYY"
            dateFormat="dd/MM/yyyy"
            showYearDropdown
            showMonthDropdown
            className={`dob border-gray-200 text-gray-700 placeholder-gray-300 cursor-pointer`}
            dropdownMode="select"
            useShortMonthInDropdown
            popperPlacement="bottom-start"
          />
          {!(state.employeeDOB == null || state.employeeDOB == '') && <img src={cancel} className={`h-5 mr-4 cursor-pointer`} onClick={() => { cancelDob() }} />}
        </div>
        {(state.employeeDOB == null || state.employeeDOB == '') && <div className='mr-2 mt-1 text-xs tracking-wide text-gray-400'>DOB is mandatory to book an appointment</div>}
        <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3'>PHONE NUMBER</div>
         <div className={`w-full mt-2 p-1 flex items-center  border border-gray-200 bg-white rounded-md text-gray-700 ${state.benefitAvailed ? 'cursor-not-allowed' : ''}`}>
            <div className='w-1/5 mr-2'>
              <Dropdown
                selectedItem={isdCode} toggleList={()=>updateOpenDropdown(!openDropdown)} listOpen={openDropdown}
                onChange={updateSelectedItem} list={allCountryIsdCode} title={isdCode} padding={"12px 8px 12px 10px"}
                dropDownIcon={dropdownDownArrow}  fontSize={'14px'} closeOnClickOverlay={true}
                marginTopOptions={'8px'} borderRequired={true} isdisable={state.benefitAvailed }
              />
            </div>
            <div className='flex justify-start justify-between w-full'>
              <input type='number' name='phone_number' value={state.employeeMobileNumber} placeholder='Enter Mobile Number'
                onBlur={(e) => {
                  let { name, value } = e.target
                  updateMobileHandler(name, value)
                }}
                onChange={(e) => {
                  let { name, value } = e.target
                  var letters = /^[0-9]*$/;
                  if (!value.match(letters)) return false
                  value = (value === ' ' ? value.trim() : value)
                  changeHandler(name, value)
                }}
                disabled={state.benefitAvailed}
                style={{ borderColor: 'transparent' }}
                className={`location placeholder-gray-300 text-base font-semibold py-1 px-0 text-gray-700 width-full ${state.benefitAvailed ? 'cursor-not-allowed' : ''}`} />
            </div>
            {!(state.employeeMobileNumber == null || state.employeeMobileNumber == '') && <img src={cancel} className={`h-5 mr-3 ${state.benefitAvailed ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => { cancelHandler() }} disabled={state.benefitAvailed} />}
          </div>
        {(state.employeeMobileNumber == null || state.employeeMobileNumber == '') && <div className='mr-2 mt-1 text-xs tracking-wide text-gray-400'>Phone Number is mandatory to book an appointment</div>}
        <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3 mb-2'>DATE OF JOINING (OPTIONAL)</div>
        <div className={`flex bg-white items-center border-gray-200 border justify-center mr-2 rounded py-1 w-full rounded-md`}>
          <img src={calendar} style={{ width: 14 }} alt='calender' className=' mx-4' />
          <DatePicker
            onChange={(e) => changeDOJ(e)}
            selected={doj}
            placeholderText="DD-MM-YYYY"
            dateFormat="dd/MM/yyyy"
            showYearDropdown
            showMonthDropdown
            className={`dob border-gray-200 text-gray-700 placeholder-gray-300 cursor-pointer`}
            dropdownMode="select"
            useShortMonthInDropdown
            popperPlacement="bottom-start"
          />
          {!(state.employeeDOJ == null || state.employeeDOJ == '') && <img src={cancel} className={`h-5 mr-4 cursor-pointer`} onClick={() => { cancelDoj() }} />}
        </div>
        <div className='flex-column box-border overflow-hidden'>
          <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3 mb-2'>PACKAGES</div>
          <PreEmpPackageSelector options={state.packages} handleSelect={updatePackageId} availablity_check={false} />
        </div>
        {
          isSelectedPackageSplit() &&
          <div className='flex-column box-border overflow-hidden'>
            <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3 mb-2'>SPLIT PACKAGES</div>
            <PreEmpPackageSelector options={splitPackages()} handleSelect={updateSplitPackageId} availablity_check={true} />
          </div>
        }
      </div>}
      <div className='bg-white h-20 flex justify-center' style={{ boxShadow: '0px -2px 10px #E5E8F0' }}>
        <button
          disabled={state.packageID == null || state.employeeDOB == null || state.employeeMobileNumber == null || state.employeeMobileNumber == '' || (isSelectedPackageSplit() && state.splitPackageID == null)}
          onClick={buttonHandler}
          className={joinButtonClasses(
            dsButtonPrimary,
            'mx-3 my-4 h-11 w-full',
            (state.packageID == null || state.employeeDOB == null || state.employeeMobileNumber == null || state.employeeMobileNumber == '' || (isSelectedPackageSplit() && state.splitPackageID == null)) && dsButtonDisabledPrimary
          )}
        >
          Next choose an address
        </button>
      </div>
    </div>
  )
}

export default PreEmpBookAppointmentModal
